import { Text } from "react-native";
import { Icon, ChevronRightIcon } from "ui/gluestack/icon";
import { Link } from "ui/gluestack/link";
import clsx from "clsx";
import { View } from "ui/atoms/view";

interface Props {
  text?: string;
  link?: string;
  colour?: string;
  hideTextOnMobile?: boolean;
}

export default function ViewMore({
  text = "View more",
  link,
  colour = "text-primary-500",
  hideTextOnMobile = false,
}: Props) {
  const isExternal = link?.startsWith("http");
  const content = (
    <>
      <Text
        className={clsx(
          "text-xs text-left",
          colour,
          hideTextOnMobile && "hidden sm:block",
        )}
      >
        {text}
      </Text>
      <Icon as={ChevronRightIcon} size="md" className="text-primary-500 ml-1" />
    </>
  );
  if (link)
    return (
      <Link
        href={link || ""}
        {...(isExternal ? { isExternal: true, target: "_blank" } : {})}
        className="flex flex-row"
      >
        {content}
      </Link>
    );

  return <View className="flex flex-row">{content}</View>;
}
